/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type Stain = {
    readonly id?: number;
    name: string;
    category: Stain.category;
    /**
     * abbrevation for the slide to show on the slide thumbnail UI
     */
    abbreviation: string;
    readonly created_at?: string;
    readonly updated_at?: string;
}

export namespace Stain {

    export enum category {
        ROUTINE = 'ROUTINE',
        TECH = 'TECH',
        SPEC = 'SPEC',
        IHC = 'IHC',
        CONTROL = 'CONTROL',
        RESCAN = 'RESCAN',
        MOL = 'MOL',
        SO = 'SO',
        ISH = 'ISH',
        FISH = 'FISH',
        IF = 'IF',
        PW_TECH = 'PW-TECH',
        PW_SPEC = 'PW-SPEC',
        PW_IHC = 'PW-IHC',
        PW_SO = 'PW-SO',
        PW_MOL = 'PW-MOL',
        PW_ISH = 'PW-ISH',
        PW_FISH = 'PW-FISH',
        CED_TECH = 'CED-TECH',
        CED_SPEC = 'CED-SPEC',
        CED_IHC = 'CED-IHC',
        CED_MOL = 'CED-MOL',
        CED_ISH = 'CED-ISH',
        CISH = 'CISH',
    }


}
